import { EspecialidadI } from "interfaces/especialidad";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { EspecialidadRow } from "./EspecialidadRow";

interface Props {
  elementos: EspecialidadI[];
  renderActions?: (elemento: EspecialidadI) => ReactNode;
}

export const EspecialidadTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedNotificacionId, setSelectedNotificacionId] = useState<
    null | number | string
  >(null);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleShowDetailModal = (id: number | string) => {
    setSelectedNotificacionId(id);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            {renderActions && (
              <th className="text-center" style={{ maxWidth: "50px" }}>
                Acciones
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <EspecialidadRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 6 : 5}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay Especialidades para visualizar.</b> Para poder
                  visualizar especialidades debes <br /> seleccionar el botón
                  agregar «Nueva Especialidad.
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
